module.exports = __webpack_public_path__ + "static/uthgardt_totems-ba4bca8e8edef46bc7bf4f4d9296ddfd.jpg";